// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__Iv2Ap","closeIcon":"styles_closeIcon__Ubd71","icon":"styles_icon__WNgfT"};